/**
 * Relative-time formatting for the project tree.
 *
 * Buckets a timestamp into the granularity the sidebar expects:
 *   < 60s   → "now"
 *   < 60m   → "{N}m ago"
 *   < 24h   → "{N}h ago"
 *   < 7d    → "{N}d ago"
 *   else    → short locale date (e.g. "Apr 28")
 */
export function formatRelative(input) {
  if (!input) return '';
  const ts = typeof input === 'number' ? input : Date.parse(input);
  if (!Number.isFinite(ts)) return '';
  const diff = Date.now() - ts;
  if (diff < 0) return 'now';
  const seconds = Math.floor(diff / 1000);
  if (seconds < 60) return 'now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  try {
    return new Date(ts).toLocaleDateString(undefined, {
      month: 'short', day: 'numeric',
    });
  } catch {
    return '';
  }
}

/**
 * Compact variant for tight rail rows ("2h", "3d", "2w") — the sidebar
 * mock shows bare units with no "ago" suffix.
 */
export function formatRelativeCompact(input) {
  if (!input) return '';
  const ts = typeof input === 'number' ? input : Date.parse(input);
  if (!Number.isFinite(ts)) return '';
  const diff = Date.now() - ts;
  if (diff < 0) return 'now';
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return 'now';
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d`;
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks}w`;
  try {
    return new Date(ts).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  } catch {
    return '';
  }
}
